import React, { Component } from 'react'

export default class DeferredYouTubePlayer extends Component {
  render() {
    const { videoId, title = 'Vidéo YouTube' } = this.props

    return (
      <iframe
        title={title}
        src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1`}
        width="100%"
        height="100%"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        loading="lazy"
        style={{
          border: 0,
          display: 'block',
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          height: '100%',
          width: '100%',
          zIndex: 3,
          backgroundColor: '#000000'
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DeferredYouTubePlayer.js